'use client';

import { useAuth } from '@/app/contexts/AuthContext';
import { useUserObras } from '@/hooks/useObras';
import LoginForm from '@/components/auth/LoginForm';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function Home() {
  const { userProfile, loading: authLoading } = useAuth();
  const { obras, loading: obrasLoading } = useUserObras();
  const router = useRouter();

  useEffect(() => {
    if (!authLoading && !obrasLoading && userProfile) {
      // Get active obras for the user
      const activeObras = obras.filter((obra) => obra.status === 'active');

      // If user has active obras, redirect to the first one
      if (activeObras.length > 0) {
        router.push(`/obras/${activeObras[0].id}/info`);
      } else if (obras.length > 0) {
        // If no active obras but has obras, go to the first available obra
        router.push(`/obras/${obras[0].id}/info`);
      } else {
        // If no obras, redirect to obras list page
        router.push('/obras-list');
      }
    }
  }, [userProfile, authLoading, obrasLoading, obras, router]);

  if (authLoading || obrasLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Show the login page for unauthenticated users
  if (!userProfile) {
    return <LoginForm />;
  }

  return null; // This shouldn't render as useEffect handles redirects
}
